// ---------------------------------------------------------------------------
// Digital Notice Board — constants
// ---------------------------------------------------------------------------
// This module is a self-contained "signage studio". It designs full-screen
// layouts (boards) made of one or more slides, each holding freely positioned
// elements (text, images, icons, notices, clock, marquee…). The finished board
// is what gets projected to a TV / LED wall via the Projection view.
//
// Coordinates are stored in LOGICAL units against a fixed design resolution
// (see CANVAS_PRESETS) so a board scales pixel-perfect to any physical display.
// ---------------------------------------------------------------------------
import {BASE_URL} from "../../../../constants/ApiConstant";

const NOTICE_BOARD = "/notice-board";

// API surface — kept module-local like the Attendance feature. Endpoints are a
// drop-in for when the backend ships; today the store falls back to the browser.
export const noticeBoardApiConstants = {
    LIST_BOARDS: BASE_URL.concat(NOTICE_BOARD),
    SAVE_BOARD: BASE_URL.concat(NOTICE_BOARD),
    DELETE_BOARD: BASE_URL.concat(NOTICE_BOARD),
};

// localStorage keys for the offline-first store.
export const STORAGE_KEYS = {
    BOARDS: "nb.boards.v1",
};

// The element kinds the studio can place on a slide.
export const ELEMENT_TYPES = {
    TEXT: "text",
    HEADING: "heading",
    IMAGE: "image",
    ICON: "icon",
    SHAPE: "shape",
    NOTICE: "notice",
    MARQUEE: "marquee",
    CLOCK: "clock",
    DATE: "date",
};

// Screen presets. width/height are the LOGICAL design canvas — everything is
// authored against these and scaled on render / projection.
export const CANVAS_PRESETS = [
    {id: "16:9", label: "Landscape 16:9 (TV / LED)", width: 1920, height: 1080},
    {id: "9:16", label: "Portrait 9:16 (Standee)", width: 1080, height: 1920},
    {id: "4:3", label: "Standard 4:3", width: 1440, height: 1080},
    {id: "21:9", label: "Ultrawide 21:9", width: 2560, height: 1080},
];

// A palette a non-technical school user can pick from quickly.
export const COLOR_SWATCHES = [
    "#1A202C", "#2D3748", "#3182CE", "#2B6CB0", "#38A169",
    "#DD6B20", "#E53E3E", "#805AD5", "#D69E2E", "#319795",
    "#FFFFFF", "#F7FAFC", "#FBD38D", "#FEB2B2", "#000000",
];

export const FONT_FAMILIES = [
    "Roboto, sans-serif",
    "'Open Sans', sans-serif",
    "Raleway, sans-serif",
    "Georgia, serif",
    "'Courier New', monospace",
];

// Default per-slide display duration (seconds) used by the projection player.
export const DEFAULT_SLIDE_DURATION = 8;
